<template>
    <section class="main-view">
        <div class="container-scroller">
            <Header :is-special-route="isSpecialRoute" @nav-visibility="onNavVisibility" @user-logout="onUserLogout" />
                <div class="container-fluid page-body-wrapper"
                    :class="[
                        'client-dashbboard',
                        {
                            Homescreen: isHomePage,
                            LoggedIn: showAfterLogin,
                            'english-header': selectedLanguage === 'en',
                            'has-bookings': navShowBooking === true,
                            'no-bookings': navShowBooking === false,
                            'has-manage-dashboard': navShowManage === true,
                            'no-manage-dashboard': navShowManage === false,
                            'search-results-page': $route.path === '/search-results'
                        }
                    ]"
                >
                <div class="main-panel">
                    <div class="content-wrapper">
                        <router-view></router-view>
                        <!-- <div class="load-content" v-if="isLoading">
                            <vue-loaders-ball-clip-rotate color="#70D3FF" scale="2.1"></vue-loaders-ball-clip-rotate>
                        </div>
                        <div v-else>
                            <router-view></router-view>
                        </div> -->
                    </div>
                    <!-- content wrapper ends -->
                    <Footer/>
                </div>
                <!-- main panel ends -->
            </div>
            <!-- WhatsApp Floating Button with Tooltip -->
            <div class="whatsapp-container">
                <div class="whatsapp-tooltip">Need help? Chat with us!</div>
                <a href="https://wa.me/971506944195" class="whatsapp-float" target="_blank" rel="noopener noreferrer">
                    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M11.972 2.008c-5.494 0-9.96 4.467-9.96 9.961 0 1.761.458 3.486 1.332 5.01L2 22.01l5.161-1.353c1.464.815 3.119 1.246 4.81 1.246 5.492 0 9.957-4.468 9.957-9.961 0-5.494-4.465-9.934-9.956-9.934zm5.541 14.364c-.233.655-1.35 1.233-1.854 1.282-.44.043-1.002.148-3.176-.754-2.617-1.082-4.275-3.753-4.404-3.924-.131-.173-1.052-1.401-1.052-2.673 0-1.272.663-1.899.897-2.149.234-.251.513-.314.685-.314.173 0 .344.004.493.011.161.008.375-.064.588.448.213.513.729 1.782.794 1.913.064.13.107.284.022.455-.086.171-.131.277-.258.427-.13.151-.274.331-.387.439-.126.12-.262.253-.119.5.143.248.636 1.054 1.365 1.701.942.837 1.737 1.096 1.986 1.217.25.121.395.103.543-.064.148-.168.641-.749.812-1.005.172-.256.344-.213.578-.125.234.089 1.482.7 1.737.828.256.128.427.191.491.298.064.108.064.623-.169 1.278z"/>
                    </svg>
                </a>
            </div>
        </div>
    </section>
</template>

<style scoped>
.whatsapp-container {
    position: fixed;
    bottom: 30px;
    right: 30px;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.whatsapp-tooltip {
    background-color: #fff;
    color: #333;
    padding: 10px 15px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: bold;
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
    margin-bottom: 12px;
    position: relative;
    white-space: nowrap;
}

.whatsapp-tooltip::after {
    content: '';
    position: absolute;
    bottom: -8px;
    right: 22px;
    border-width: 8px 8px 0;
    border-style: solid;
    border-color: #fff transparent transparent transparent;
    display: block;
    width: 0;
}

.whatsapp-float {
    width: 60px;
    height: 60px;
    background-color: #25d366;
    color: #FFF;
    border-radius: 50px;
    text-align: center;
    box-shadow: 2px 2px 8px rgba(0,0,0,0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    transition: background-color 0.3s, transform 0.3s;
}

.whatsapp-float:hover {
    background-color: #128c7e;
    transform: translateY(-3px);
    color: #FFF;
    text-decoration: none;
}

@media (max-width: 767px) {
    .whatsapp-container {
        bottom: 20px;
        right: 20px;
    }
    .whatsapp-float {
        width: 50px;
        height: 50px;
    }
    .whatsapp-float svg {
        width: 28px;
        height: 28px;
    }
    .whatsapp-tooltip {
        font-size: 12px;
        padding: 8px 12px;
        margin-bottom: 10px;
    }
    .whatsapp-tooltip::after {
        right: 17px;
    }
}
</style>

<script>
import Header from "./partials/Header";
import Footer from "./partials/Footer";
import Vue from 'vue';

export default {
    name: "guest_layout",
    components: {
        Header,
        Footer,
    }, 
    data() {
        return {
            getPermissionsData: [],
            isLoading: true,
            showAfterLogin: false,
            selectedLanguage: '',
            currentLanguage:''
            ,
            // nav visibility flags set by Header via event
            navShowBooking: null,
            navShowManage: null
        };
    }, 
    computed: {
        isSpecialRoute() {
            return this.$route.name === "property_detail"; 
        },
        isHomePage() {
            return this.$route.name === "home"; // Adjust if your home route uses a different name
        }
    },
    beforeMount() {
        this.getPermissions();
    }, 
    mounted() { 
        this.Authorization = localStorage.getItem('isLoggedin');
        if (this.Authorization !== null) {
            this.showAfterLogin = true;
            this.showBeforeLogin = false;
        } else {
            this.showBeforeLogin = true;
        }
        Vue.prototype.$EventBus.$on('changeLanguage', this.onLanguageChanged);
        // restore selected language so header class reflects persisted choice on reload
        const persisted = localStorage.getItem('selectedLanguage');
        if (persisted) {
            this.selectedLanguage = persisted;
            this.currentLanguage = persisted === 'en' ? '' : `_${persisted}`;
        }
    }, 
    methods: {
        changeLanguage(language) {
            Vue.prototype.$EventBus.$emit('changeLanguage', language);
            this.selectedLanguage = language;
            try {
                localStorage.setItem('selectedLanguage', language);
            } catch (e) {
                console.warn('Unable to persist selectedLanguage to localStorage', e);
            }
        },
        onLanguageChanged(language) {
            // Keep both selectedLanguage and currentLanguage in sync
            this.selectedLanguage = language;
            this.currentLanguage = language === 'en' ? '' : `_${language}`;
            try {
                localStorage.setItem('selectedLanguage', language);
            } catch (e) {
                console.warn('Unable to persist selectedLanguage to localStorage', e);
            }
        },
        handleIsLoading(data) {
            this.isLoading = data;
        },
        onNavVisibility(payload) {
            // payload: { showBooking: boolean, showManage: boolean }
            if (payload && typeof payload === 'object') {
                this.navShowBooking = payload.showBooking ?? null;
                this.navShowManage = payload.showManage ?? null;
            }
        },
        onUserLogout() {
            // Header emitted logout — update layout state so LoggedIn class is removed immediately
            try { localStorage.removeItem('isLoggedin'); } catch (e) { console.warn(e); }
            this.showAfterLogin = false;
            this.navShowBooking = false;
            this.navShowManage = false;
        },
        logout() {
            // Clear login flag so mounted check and other components see logged-out state
            try {
                localStorage.removeItem('isLoggedin');
            } catch (e) {
                console.warn('Unable to remove isLoggedin from localStorage', e);
            }
            try {
                localStorage.removeItem('userPermissions');
            } catch (e) {
                console.warn('Unable to remove userPermissions from localStorage', e);
            }
            this.showAfterLogin = false;
            this.showBeforeLogin = true;
        },
        getPermissions() {
            // this.getPermissionsData = JSON.parse(this.$session.get('userPermissions'));
            this.getPermissionsData = JSON.parse(localStorage.getItem('userPermissions'));
        },
        permissionExist(param) {
            var check = this.getPermissionsData.includes(param);
            if (check) {
                return true;
            } else {
                return false;
            }
        }
    },
    beforeDestroy() {
        Vue.prototype.$EventBus.$off('changeLanguage', this.onLanguageChanged);
    },
};
</script>
